import React, { useState } from 'react';

import clsx from 'clsx';
import { DotsSixVertical } from '@phosphor-icons/react';
import { ContactRecord } from 'src/services/integration-app.service';

export interface CrmField {
  value: string;
  label: string;
  description?: string;
}

interface DraggableCrmFieldProps {
  field: CrmField;
  sampleContacts?: ContactRecord[];
  sourceCampaignField?: string;
}

export const DraggableCrmField: React.FC<DraggableCrmFieldProps> = ({
  field,
  sampleContacts = [],
}) => {
  const [isDragging, setIsDragging] = useState(false);

  const getSampleValues = (): string[] => {
    if (sampleContacts.length === 0) return [];

    return sampleContacts
      .slice(0, 3)
      .map((contact) => {
        const fieldValue =
          contact.fields[field.value as keyof typeof contact.fields];
        return fieldValue ? String(fieldValue) : '';
      })
      .filter((value) => value.trim() !== '');
  };
  const sampleValues = getSampleValues();

  const handleDragStart = (e: React.DragEvent) => {
    e.dataTransfer.setData('text/plain', field.value);
    e.dataTransfer.effectAllowed = 'move';

    setIsDragging(true);
  };

  const handleDragEnd = () => {
    setIsDragging(false);
  };

  return (
    <div
      draggable
      onDragStart={handleDragStart}
      onDragEnd={handleDragEnd}
      className={clsx(
        'p-3 border border-neutral-200 rounded-lg transition-colors min-h-[120px]',
        isDragging
          ? 'opacity-50 bg-primary-100 border-primary-300 cursor-grabbing'
          : 'cursor-grab hover:bg-neutral-50 active:cursor-grabbing bg-neutral-0',
      )}
    >
      <div className="flex items-start h-full">
        <div className="flex-shrink-0 mr-3 mt-1">
          <DotsSixVertical size={16} />
        </div>
        <div className="flex-1 min-w-0 flex flex-col">
          <div className="font-medium text-neutral-900 truncate">
            {field.label}
          </div>
          <div className="mt-2 flex-1">
            <div className="space-y-1">
              {sampleValues.length > 0 ? (
                sampleValues.map((value, index) => (
                  <div
                    key={index}
                    className="text-xs text-neutral-500 truncate"
                    title={value}
                  >
                    {value}
                  </div>
                ))
              ) : (
                <div className="space-y-1">
                  <div className="text-xs text-neutral-300">&nbsp;</div>
                  <div className="text-xs text-neutral-300">&nbsp;</div>
                  <div className="text-xs text-neutral-300">&nbsp;</div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
